// extracted by mini-css-extract-plugin
export default {"container":"GyiVV9","thumbnail-wrapper":"r9yavI","thumbnailWrapper":"r9yavI","prev-button":"tO_1ZK","prevButton":"tO_1ZK","next-button":"ixdP0F","nextButton":"ixdP0F"};